// submitCustomer.ts — sanitasi data customer + alamat untuk payload order
import type { Form } from '../../../../types';
import { sanitizeInput, sanitizeEmail, sanitizePhone } from '../../../../utils/sanitization';
import { normalizePhoneForDb } from '../../../../utils/formatPhone';
import { getEffectiveMaxSubsidy } from '../../../../utils/shippingSubsidy';

export interface CustomerFields {
  name: string; email: string; phone: string;
  productName: string; sellingPrice: number; comparePrice: number; varName: string;
  brandId: string; province: string; city: string; district: string; village: string;
  addressText: string; isConsult: boolean; isHerbal: boolean;
  finalShippingAddress: string; herbalSubsidy: number;
}

export function buildCustomerFields(form: Form | null, customerData: any, addressData: any, selectedOptions: Record<string, string>, linkedProductName: string, currentCombination: any, isSimpleEmbed: boolean | undefined, herbalClaimMode: 'wa' | 'claim_ongkir' | undefined, quantity?: number | null): CustomerFields {
  const name = sanitizeInput(customerData.name) || '-';
  const email = sanitizeEmail(customerData.email) || '';
  // Normalisasi ikut negara form: MY '012...' → '601...', ID '08...' → '628...'.
  const phone = normalizePhoneForDb(sanitizePhone(customerData.whatsapp) || '', (form as any)?.addressCountry === 'MY' ? '60' : '62');
  const productName = linkedProductName || sanitizeInput(form?.title || '') || '-';
  const sellingPrice = currentCombination?.sellingPrice ?? form?.productPrice ?? 0;
  const comparePrice = currentCombination?.comparePrice ?? form?.productComparePrice ?? 0;
  const varName = selectedOptions ? Object.values(selectedOptions).join(' / ') : '';
  const brandId = form?.brandId || '';
  const province = sanitizeInput(addressData.province || '') || '';
  const city = sanitizeInput(addressData.city || '') || '';
  const district = sanitizeInput(addressData.district || '') || '';
  const village = sanitizeInput(addressData.village || '') || '';
  const addressText = sanitizeInput((addressData.detailAddress || addressData.fullAddress || '').trim()) || '';
  const isConsult = !!(form as any)?.thankYouPage?.consultationMode;
  const isHerbal = form?.addressInputMode === 'simple' || isSimpleEmbed || isConsult;
  const finalShippingAddress = (isHerbal && herbalClaimMode === 'wa') ? '' : addressText;
  const herbalSubsidy = (isHerbal && herbalClaimMode === 'claim_ongkir') ? getEffectiveMaxSubsidy(form, currentCombination ?? null, quantity ?? 1) : 0;
  return { name, email, phone, productName, sellingPrice, comparePrice, varName, brandId, province, city, district, village, addressText, isConsult, isHerbal, finalShippingAddress, herbalSubsidy };
}
